import { ApiService } from '../../../ApiService';

interface DocumentData {
  id: number;
  filename: string;
}

export interface RecentApplicationData {
  company?: string;
  jobTitle?: string;
  yearsExperience?: string;
  academicDegree?: string;
  portfolioUrl?: string;
  salaryExpectation?: number;
  salaryCurrency?: string;
  candidateDetail?: string;
  hasWorkingVisa?: boolean;
  sourceId?: number;
  isReferral?: boolean;
  referralKnowledge?: boolean;
  referrerUserId?: number;
  referrerEmail?: string;
  resume?: DocumentData;
  coverLetter?: DocumentData;
  documents: DocumentData[];
}

export class CandidateService {
  public static getRecentApplication(
    candidateId: number,
  ): Promise<RecentApplicationData | null> {
    return ApiService.get<RecentApplicationData | null>(
      `/api/v1/applicant_tracking/candidates/${candidateId}/recent_application`,
    );
  }
}
